import { create } from "zustand";
import { RelocationItemInput } from "@/gql/graphql";

type ImportState = {
  relocations: RelocationItemInput[];
  addRelocations: (relocations: RelocationItemInput[]) => void;
  reset: () => void;
};

// Number of blank rows the grid is seeded with for manual entry / paste.
// AG-Grid paste won't create rows beyond those that already exist, so this
// is effectively the manual-paste row cap. Kept high for bulk imports.
const BLANK_ROW_COUNT = 5000;

const buildInitialState = () =>
  Array.from({
    length: BLANK_ROW_COUNT,
  }).map(() => ({})) as RelocationItemInput[];

export const useImportState = create<ImportState>()((set) => ({
  relocations: buildInitialState(),
  addRelocations: (relocations) => set(() => ({ relocations })),
  reset: () =>
    set(() => {
      return {
        relocations: buildInitialState(),
      };
    }),
}));
